// SCSS Imports
import "./UserAccount.scss";

// React Imports

// Component Imports
import UserAccountData from "../components/UserAccountData.js";

// Image Imports

// Font Awesome Icons

const UserAccount = () => {
    return (
        <>
            <UserAccountData />
        </>
    );
};
export default UserAccount;
